import GoPageV2 from './GoPage.v2'

export default GoPageV2
// eslint-disable-next-line import/export
export * from './GoPage.v2'
